class MegaMenu extends HTMLElement {
  constructor() {
    super();
    this.megaMenuItems = document.querySelectorAll('nav.header__inline-menu > ul > li');
    this.currentMenuItem = null;
    this.timer = null;

    this.megaMenuItems.forEach((menuItem) => {
      if (!menuItem.hasAttribute('data-event-listener-added')) {
        menuItem.setAttribute('data-event-listener-added', 'true');

        menuItem.addEventListener('mouseenter', () => {
          if (!menuItem.classList.contains('active')) {
            this.clearTimer();
            this.currentMenuItem = menuItem;
            this.openDropdown(menuItem);
            const category = menuItem.dataset.category;

            let isDelayed = false;
            const delay = 400;
            this.timer = setTimeout(() => {
              isDelayed = true;
              this.sendCustomEvent(category);
            }, delay);

            menuItem.addEventListener('mouseleave', () => {
              if (!isDelayed) {
                clearTimeout(this.timer);
              }
            });
          }
        });

        menuItem.addEventListener('mouseleave', () => {
          if (menuItem.classList.contains('active')) {
            this.closeDropdown(menuItem);
          }
        });

        const anchorTags = menuItem.querySelectorAll('a');
        anchorTags.forEach((anchor) => {
          anchor.addEventListener('click', (event) => {
            event.preventDefault();
            const category = menuItem.dataset.category;
            const url = anchor.href;
            const title = anchor.title;
            this.sendAnchorClickEvent(category, url, title);
          });
        });
      }
    });
  }

  openDropdown(menuItem) {
    const details = menuItem.querySelector('details');
    if (details) {
      menuItem.classList.add('active');
      details.open = true;
      const megaMenuContent = details.querySelector('.mega-menu__content');
      megaMenuContent.addEventListener('mouseleave', () => {
        this.closeDropdown(menuItem);
      });
      details.addEventListener('mouseleave', () => {
        this.closeDropdown(menuItem);
      });
    }
  }

  closeDropdown(menuItem) {
    const details = menuItem.querySelector('details');
    if (details) {
      menuItem.classList.remove('active');
      details.open = false;
    }
  }

  sendCustomEvent(category) {
    if (typeof gtag === 'function') {
      gtag('event', 'interact_main_nav', {
        category: category,
        form_factor: 'Desktop Navigation',
      });
    }
  }

  sendAnchorClickEvent(category, url, title) {
    title = title.replace(/\|/g, ' ');

    if (typeof gtag === 'function') {
      gtag('event', 'select_main_nav', {
        category: category,
        form_factor: 'Desktop Navigation',
        title: title,
        link_url: url,
      });
    }

    window.location.href = url;
  }

  clearTimer() {
    clearTimeout(this.timer);
    this.timer = null;
  }
}

customElements.define('mega-menu', MegaMenu);
